import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	chatRecovery: {
		id: 'errorChat.recovery',
		defaultMessage: 'Что-то пошло не так. Перезагрузите страницу.',
	},
});
